import { dispatchActiveTabChange } from '../../runtimeBridge'
import {
   type ViewTransitionDirection,
   activeTab,
   getAdjacentAppTab,
   setActiveTab,
} from '../../state/appUiStore'

/**
 * Activates the neighboring tab in the ordered app navigation.
 *
 * @param direction - Which side of the active tab to activate.
 * @returns True when a tab changed.
 */
export function activateAdjacentTab(direction: ViewTransitionDirection): boolean {
   const nextTab = getAdjacentAppTab(activeTab(), direction)
   if (!nextTab) {
      return false
   }
   setActiveTab(nextTab, { direction })
   dispatchActiveTabChange(nextTab)
   return true
}
